import { useEffect } from "react";
import { useLocation } from "react-router";

import { applyVisitLocale } from "@/i18n";
import { isMarketingPath, localeForPath, readStoredLocaleChoice } from "@/i18n/locales";
import { upsertMeta } from "./document-meta";

/**
 * First visit to `/` and `/equipos` is English. Everywhere else stays Spanish
 * until the visitor stores a choice. Private routes stay out of search.
 */
export function LocaleRouteSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    const stored = readStoredLocaleChoice();

    if (!stored) {
      void applyVisitLocale(localeForPath(pathname, null));
    }

    upsertMeta("name", "robots", isMarketingPath(pathname) ? "index, follow" : "noindex, nofollow");
  }, [pathname]);

  return null;
}
